import React from "react";
import { Table, Tabs } from "antd";
import dayjs from "dayjs";
import "./style.css";

const data2024 = [
  {
    key: 1,
    date: "14-Jan-2024",
    day: "Sunday",
    festival: "Makar Sankranti",
    note: "",
  },
  {
    key: 2,
    date: "15-Jan-2024",
    day: "Monday",
    festival: "Vasi Uttarayan",
    note: "Extra",
  },
  {
    key: 3,
    date: "22-Jan-2024",
    day: "Monday",
    festival: "Ayodhya Ram Mandir day",
    note: "",
  },
  {
    key: 4,
    date: "26-Jan-2024",
    day: "Friday",
    festival: "Republic Day",
    note: "",
  },
  {
    key: 5,
    date: "8-Mar-2024",
    day: "Monday",
    festival: "Maha Shivratri",
    note: "Cancel",
  },
  {
    key: 6,
    date: "25-Mar-2024",
    day: "Monday",
    festival: "Holi/Dhuleti",
    note: "",
  },
  {
    key: 7,
    date: "29-Mar-2024",
    day: "Friday",
    festival: "Good Friday",
    note: "Cancel",
  },
  {
    key: 8,
    date: "11-Apr-2024",
    day: "Thursday",
    festival: "Ramjan-Eid",
    note: "Cancel",
  },
  {
    key: 9,
    date: "14-Apr-2024",
    day: "Sunday",
    festival: "Baba Saheb Ambedkar's Birthday",
    note: "Cancel",
  },
  {
    key: 10,
    date: "17-Apr-2024",
    day: "Wednesday",
    festival: "Shree Ram Navmi",
    note: "Cancel",
  },
  {
    key: 11,
    date: "21-Apr-2024",
    day: "Sunday",
    festival: "Mahavir Janma Kalyanak",
    note: "Cancel",
  },
  {
    key: 12,
    date: "17-Jun-2024",
    day: "Monday",
    festival: "Bakri Eid",
    note: "Cancel",
  },
  {
    key: 13,
    date: "15-Aug-2024",
    day: "Thursday",
    festival: "Independence Day",
    note: "",
  },
  {
    key: 14,
    date: "19-Aug-2024",
    day: "Monday",
    festival: "Raksha Bandhan",
    note: "",
  },
  {
    key: 15,
    date: "26-Aug-2024",
    day: "Monday",
    festival: "Janmashtami",
    note: "",
  },
  {
    key: 16,
    date: "7-Sep-2024",
    day: "Saturday",
    festival: "Samvatsari",
    note: "Cancel",
  },
  {
    key: 17,
    date: "16-Sep-2024",
    day: "Monday",
    festival: "Bara Vafat",
    note: "Cancel",
  },
  {
    key: 18,
    date: "2-Oct-2024",
    day: "Wednesday",
    festival: "Mahatma Gandhi's Birthday",
    note: "Cancel",
  },
  {
    key: 19,
    date: "12-Oct-2024",
    day: "Saturday",
    festival: "Vijayadashami",
    note: "",
  },
  {
    key: 20,
    date: "31-Oct-2024",
    day: "Thursday",
    festival: "Sardar Vallabhbhai Patel's Birthday",
    note: "Cancel",
  },
  {
    key: 21,
    date: "31-Oct-2024",
    day: "Thursday",
    festival: "Diwali",
    note: "",
  },
  {
    key: 22,
    date: "2-Nov-2024",
    day: "Saturday",
    festival: "New Year Day",
    note: "",
  },
  {
    key: 23,
    date: "3-Nov-2024",
    day: "Sunday",
    festival: "Bhai Bij",
    note: "",
  },
  {
    key: 24,
    date: "4-Nov-2024",
    day: "Monday",
    festival: "Treej",
    note: "Extra",
  },
  {
    key: 25,
    date: "5-Nov-2024",
    day: "Tuesday",
    festival: "Choth",
    note: "Extra",
  },
  {
    key: 26,
    date: "6-Nov-2024",
    day: "Wednesday",
    festival: "Pacham",
    note: "Extra",
  },
  {
    key: 27,
    date: "25-Dec-2024",
    day: "Wednesday",
    festival: "Christmas",
    note: "Cancel",
  },
];

const data2025 = [
  {
    key: 1,
    date: "14-Jan-2025",
    day: "Tuesday",
    festival: "Makar Sankranti",
    note: "",
  },
  {
    key: 2,
    date: "15-Jan-2025",
    day: "Wednesday",
    festival: "Makar Sankranti",
    note: "Extra",
  },
  {
    key: 4,
    date: "26-Jan-2025",
    day: "Sunday",
    festival: "Republic Day",
    note: "",
  },
  {
    key: 5,
    date: "26-Feb-2025",
    day: "Wednesday",
    festival: "Maha Shivratri",
    note: "Cancel",
  },
  {
    key: 6,
    date: "15-Mar-2025",
    day: "Friday",
    festival: "Holi/dhuleti",
    note: "",
  },
  {
    key: 7,
    date: "31-Mar-2025",
    day: "Monday",
    festival: "Ramjan-Eid",
    note: "Cancel",
  },
  {
    key: 8,
    date: "13-Apr-2025",
    day: "Sunday",
    festival: "Pesach",
    note: "",
  },
  {
    key: 9,
    date: "14-Apr-2025",
    day: "Sunday",
    festival: "Baba Saheb Ambedkar's Birthday",
    note: "Cancel",
  },
  {
    key: 10,
    date: "17-Apr-2025",
    day: "Wednesday",
    festival: "Shree Ram Navami",
    note: "Cancel",
  },
  {
    key: 11,
    date: "18-Apr-2025",
    day: "Friday",
    festival: "Good Friday",
    note: "Cancel",
  },
  {
    key: 12,
    date: "19-Apr-2025",
    day: "Saturday",
    festival: "7th day of Pesach",
    note: "",
  },
  {
    key: 13,
    date: "21-Apr-2025",
    day: "Sunday",
    festival: "Mahavir Janma Kalyanak",
    note: "Cancel",
  },
  {
    key: 14,
    date: "1-May-2025",
    day: "Thursday",
    festival: "Yom Ha-Atzmaut",
    note: "",
  },
  {
    key: 15,
    date: "2-Jun-2025",
    day: "Monday",
    festival: "Shavuot",
    note: "",
  },
  {
    key: 16,
    date: "17-Jun-2025",
    day: "Monday",
    festival: "Eid-ul-Adha",
    note: "Cancel",
  },
  {
    key: 17,
    date: "23-Sep-2025",
    day: "Tuesday",
    festival: "Rosh Hashanah",
    note: "",
  },
  {
    key: 18,
    date: "24-Sep-2025",
    day: "Wednesday",
    festival: "Rosh Hashanah",
    note: "",
  },
  {
    key: 19,
    date: "2-Oct-2025",
    day: "Thursday",
    festival: "Mahatma Gandhi's Birthday",
    note: "Cancel",
  },
  {
    key: 20,
    date: "2-Oct-2025",
    day: "Thursday",
    festival: "Vijaydashmi",
    note: "",
  },
  {
    key: 21,
    date: "2-Oct-2025",
    day: "Thursday",
    festival: "Yom Kippur",
    note: "",
  },
  {
    key: 22,
    date: "7-Oct-2025",
    day: "Tuesday",
    festival: "Sukkot",
    note: "",
  },
  {
    key: 23,
    date: "14-Oct-2025",
    day: "Tuesday",
    festival: "Simchat Torah",
    note: "",
  },
  {
    key: 24,
    date: "20-Oct-2025",
    day: "Monday",
    festival: "Diwali",
    note: "",
  },
  {
    key: 25,
    date: "22-Oct-2025",
    day: "Wednesday",
    festival: "New Year Day",
    note: "",
  },
  {
    key: 26,
    date: "23-Oct-2025",
    day: "Thursday",
    festival: "Bhai Bij",
    note: "",
  },
  {
    key: 27,
    date: "24-Oct-2025",
    day: "Friday",
    festival: "Treej",
    note: "Extra",
  },
  {
    key: 28,
    date: "25-Oct-2025",
    day: "Saturday",
    festival: "Choth",
    note: "Extra",
  },
  {
    key: 29,
    date: "26-Oct-2025",
    day: "Sunday",
    festival: "Pacham",
    note: "Extra",
  },
  {
    key: 30,
    date: "31-Oct-2025",
    day: "Friday",
    festival: "Sardar Vallabhbhai Patel's Birthday",
    note: "Cancel",
  },
  {
    key: 31,
    date: "25-Dec-2025",
    day: "Thursday",
    festival: "Christmas",
    note: "",
  },
];

const data2026 = [
  {
    key: 1,
    date: "14-Jan-2026",
    day: "Wednesday",
    festival: "Makar Sankranti",
    note: "",
  },
  {
    key: 2,
    date: "15-Jan-2026",
    day: "Thursday",
    festival: "Makar Sankranti",
    note: "Extra",
  },
  {
    key: 3,
    date: "26-Jan-2026",
    day: "Monday",
    festival: "Republic Day",
    note: "",
  },
  {
    key: 4,
    date: "15-Feb-2026",
    day: "Sunday",
    festival: "Maha Shivratri",
    note: "Cancel",
  },
  {
    key: 5,
    date: "4-Mar-2026",
    day: "Wednesday",
    festival: "Holi/dhuleti",
    note: "",
  },
  {
    key: 6,
    date: "21-Mar-2026",
    day: "Saturday",
    festival: "Ramjan-Eid",
    note: "Cancel",
  },
  {
    key: 7,
    date: "27-Mar-2026",
    day: "Friday",
    festival: "Shree Ram Navami",
    note: "Cancel",
  },
  {
    key: 8,
    date: "1-Apr-2026",
    day: "Wednesday",
    festival: "Mahavir Janma Kalyanak",
    note: "Cancel",
  },
  {
    key: 9,
    date: "3-Apr-2026",
    day: "Friday",
    festival: "Good Friday",
    note: "Cancel",
  },
  {
    key: 10,
    date: "14-Apr-2026",
    day: "Tuesday",
    festival: "Baba Saheb Ambedkar's Birthday",
    note: "Cancel",
  },
  {
    key: 11,
    date: "1-May-2026",
    day: "Friday",
    festival: "Labour Day",
    note: "",
  },
  {
    key: 12,
    date: "27-May-2026",
    day: "Wednesday",
    festival: "Eid-ul-Adha",
    note: "Cancel",
  },
  {
    key: 13,
    date: "15-Aug-2026",
    day: "Saturday",
    festival: "Independence Day",
    note: "",
  },
  {
    key: 14,
    date: "28-Aug-2026",
    day: "Friday",
    festival: "Raksha Bandhan",
    note: "",
  },
  {
    key: 15,
    date: "4-Sep-2026",
    day: "Friday",
    festival: "Janmashtami",
    note: "",
  },
  {
    key: 16,
    date: "2-Oct-2026",
    day: "Friday",
    festival: "Mahatma Gandhi's Birthday",
    note: "Cancel",
  },
  {
    key: 17,
    date: "20-Oct-2026",
    day: "Tuesday",
    festival: "Vijaydashmi",
    note: "",
  },
  {
    key: 18,
    date: "31-Oct-2026",
    day: "Saturday",
    festival: "Sardar Vallabhbhai Patel's Birthday",
    note: "Cancel",
  },
  {
    key: 19,
    date: "8-Nov-2026",
    day: "Sunday",
    festival: "Diwali",
    note: "",
  },
  {
    key: 20,
    date: "10-Nov-2026",
    day: "Tuesday",
    festival: "New Year Day",
    note: "",
  },
  {
    key: 21,
    date: "11-Nov-2026",
    day: "Wednesday",
    festival: "Bhai Bij",
    note: "",
  },
  {
    key: 22,
    date: "12-Nov-2026",
    day: "Thursday",
    festival: "Treej",
    note: "Extra",
  },
  {
    key: 23,
    date: "13-Nov-2026",
    day: "Friday",
    festival: "Choth",
    note: "Extra",
  },
  {
    key: 24,
    date: "14-Nov-2026",
    day: "Saturday",
    festival: "Pacham",
    note: "Extra",
  },
  {
    key: 25,
    date: "25-Dec-2026",
    day: "Friday",
    festival: "Christmas",
    note: "",
  },
];

const columns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Day",
    dataIndex: "day",
    key: "day",
  },
  {
    title: "Festival",
    dataIndex: "festival",
    key: "festival",
  },
  {
    title: "Note",
    dataIndex: "note",
    key: "note",
  },
];

const monthMap = {
  Jan: "jan",
  Feb: "feb",
  Mar: "mar",
  Apr: "apr",
  May: "may",
  Jun: "jun",
  Jul: "jul",
  Aug: "aug",
  Sep: "sep",
  Oct: "oct",
  Nov: "nov",
  Dec: "dec",
};

const getRowClassName = (record) => {
  const monthMatch = record.date.match(/-(\w+)-/);
  const month = monthMatch ? monthMatch[1] : null;
  return month && monthMap[month] ? `row-${monthMap[month]}` : "";
};

const items = [
  {
    key: "3",
    label: "2026",
    children: (
      <Table
        columns={columns}
        dataSource={data2026}
        bordered
        pagination={false}
        rowClassName={getRowClassName}
      />
    ),
  },
  {
    key: "1",
    label: "2025",
    children: (
      <Table
        columns={columns}
        dataSource={data2025}
        bordered
        pagination={false}
        rowClassName={getRowClassName}
      />
    ),
  },
  {
    key: "2",
    label: "2024",
    children: (
      <Table
        columns={columns}
        dataSource={data2024}
        bordered
        pagination={false}
        rowClassName={getRowClassName}
      />
    ),
  },
];

const OfficialHolidays = () => {
  return <Tabs defaultActiveKey="3" items={items} />;
};

export default OfficialHolidays;
